module.exports = __webpack_public_path__ + "img/yellow.821dcaf6.png";